import PropTypes from 'prop-types';
import { or } from 'airbnb-prop-types';

export const MenuItemLabelType = PropTypes.string;
export const MenuItemKeyType = PropTypes.string;
export const MenuItemPrivateType = PropTypes.bool;
export const MenuItemUrlType = PropTypes.string;
export const MenuItemIsExternalType = PropTypes.bool;

const baseMenuItem = {
  label: MenuItemLabelType.isRequired,
  key: MenuItemKeyType.isRequired,
  private: MenuItemPrivateType,
  isExternal: MenuItemIsExternalType,
};

const ExternalLinkSmallItemType = {
  label: MenuItemLabelType.isRequired,
  url: MenuItemUrlType.isRequired,
};

const ExternalLinkMenuType = {
  ...baseMenuItem,
  url: MenuItemUrlType.isRequired,
};

const actionType = PropTypes.string;
export const MenuItemActionType = PropTypes.shape({
  type: actionType.isRequired,
  payload: PropTypes.object,
});

const ActionMenuSmallItemType = {
  label: MenuItemLabelType.isRequired,
  action: MenuItemActionType.isRequired,
};

const ActionMenuItemType = {
  ...baseMenuItem,
  action: MenuItemActionType.isRequired,
};

export const MenuItemSmallType = or([
  PropTypes.shape(ExternalLinkSmallItemType),
  PropTypes.shape(ActionMenuSmallItemType),
]);

const ParentMenuItemType = {
  ...baseMenuItem,
};

const MenuItemType = or([
  PropTypes.shape(ExternalLinkMenuType),
  PropTypes.shape(ActionMenuItemType),
  PropTypes.shape(ParentMenuItemType),
]);
ExternalLinkMenuType.children = PropTypes.arrayOf(MenuItemType);
ActionMenuItemType.children = PropTypes.arrayOf(MenuItemType);
ParentMenuItemType.children = PropTypes.arrayOf(MenuItemType).isRequired;

export { MenuItemType };

const MenuType = PropTypes.arrayOf(MenuItemType);

export default MenuType;



// WEBPACK FOOTER //
// ./src/lib/proptypes/menu.proptypes.js